import { ActivityContextType } from "@/modules/lead-page/new/context/activity.context";
import { createContext, useContext } from "react";

export const ActivityContext = createContext<ActivityContextType | undefined>(
  undefined
);

export const useActivityContext = (): ActivityContextType => {
  const context = useContext(ActivityContext);
  if (!context) {
    throw new Error(
      "useActivityContext must be used within an ActivityProvider"
    );
  }
  return context;
};
